<template>
    <b-col
   
      class="subscription-col col-md-4"
    
    >
    <b-card
        class="subscription-card border"
        :class="{'active-subscription': current_subscription && current_subscription.subscription_type.id == subscription.id}"
    >
        <div class="header-card">
        <h3>{{ subscription.name }}</h3>
        <div
            v-if="current_subscription && current_subscription.subscription_type.id == subscription.id"
            class="pastille-current"
        >
            Current plan
        </div> 
        </div>
        <br /> 
        <b-card-text class="subscription-price">
        €<span class="amount-sub">{{ subscription.price }}</span> / month
        </b-card-text>
        <b-button
            v-if="(current_subscription && current_subscription.subscription_type.id != subscription.id) || !current_subscription"
            :href="'/subscription/'+subscription.id+'/'+current_user_id"
            variant="secondary"
        >
            Select this plan
        </b-button> 
        <b-button
            v-else
            variant="dark"
            
        >
            See my options
        </b-button>

        <br /><br />
        <template v-for="element in subscription.subscription_elements">
          <div class="sub-item" v-if="element.counter_type == 'scans'">
              <div class="sub-left">
              <img src="@/assets/images/scans.svg" alt="Scan" />
              <span>
                  Included scans
                  <div class="grey-color">{{ element.quota }} scans / month</div>
              </span>
              </div>
              <div class="sub-right">{{ element.quota }}</div>
          </div>
        </template>
        <br />
        <div class="sub-item">
            <div class="sub-left">
            <img src="@/assets/images/devices.svg" alt="Scan" />
            <span>
                Devices included
                <div class="grey-color">+{{ subscription.device_price }}€ extra device</div>
            </span>
            </div>
            <div class="sub-right">{{ subscription.devices_number }}</div>
        </div>

        <br />
        <div class="sub-item-big">
            <div class="sub-left">
            <img src="@/assets/images/check.svg" alt="Scan" />
            <span>White-label Mobile App</span>
            </div>
            <div class="sub-left">
            <img src="@/assets/images/check.svg" alt="Scan" />
            <span>Eyewear Digitization Studio</span>
            </div>
            <div class="sub-left">
            <img src="@/assets/images/check.svg" alt="Scan" />
            <span>Face Scan Measurements</span>
            </div>
            <div class="sub-left">
            <img src="@/assets/images/check.svg" alt="Scan" />
            <span>Face Report Generation</span>
            </div>
            <div class="sub-left">
            <img src="@/assets/images/check.svg" alt="Scan" />
            <span>Catalog Filtering & Recommendations</span>
            </div>
            <div class="sub-left">
            <img src="@/assets/images/check.svg" alt="Scan" />
            <span>Complete Product Page</span>
            </div>
            <div class="sub-left">
            <img src="@/assets/images/check.svg" alt="Scan" />
            <span>Dashboard</span>
            </div>
            <div class="sub-left">
            <img src="@/assets/images/check.svg" alt="Scan" />
            <span>Activity Logs</span>
            </div>
        
            
        </div>

        <br />

        <template v-for="element in subscription.subscription_elements">
          <span v-if="element.counter_type == 'scans'" class="grey-color">Scan overage: </span>{{ element.amount }}€ / scan

        </template>

   
    </b-card>
    </b-col>
  </template>
  
  <script>
  import {BModal, BButton, BOverlay, BRow, BCol, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
  export default {
    name: 'SubscriptionElement',
    props:['subscription','current_subscription','current_user_id'],
    components: {
      BCard,
      BCardText,
      BButton,
      BCol,
      BRow,
      BModal,
      BOverlay,
      BAvatar,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
    }
  }
  </script>
  
  <style scoped>
 
.subscription-price
{
  color:#999;
  font-size:22px;
}
.subscription-price .amount-sub
{
  color:#000;
  font-size:40px;
}
.subscription-card .btn
{
  width:100%;
}
.subscription-row {
  margin: 0 -10px;
}

.subscription-col {
  padding: 10px;
}
.sub-right
{
  font-size:22px;
}
.sub-left
{
  display:flex;
  align-items: flex-start;
  gap:10px;text-align: left;
}
.sub-left img
{
 position:relative;
 top:4px;
}
.sub-item-big
{
  flex-direction: column;
  background:#f1f1f1;
  padding:15px;
  gap:10px;
  border-radius:5px;
  display:flex;
  justify-content: space-between;
  align-items: flex-start;
}
.sub-item
{
  background:#f1f1f1;
  padding:10px;
  border-radius:5px;
  display:flex;
  justify-content: space-between;
  align-items: flex-start;
}
.active-subscription .sub-item,.active-subscription .sub-item-big
{
  background-color: #fff !important;
}
.active-subscription
{
  background-color: #f1f1f1 !important;
}
.pastille-current
{
  background-color: #fff;

  padding:5px 10px;
  border-radius:5px;
  font-size:12px;
  color:#000;
  position: absolute;
  top:20px;
  right:10px;
}
  </style>